import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ProposalsPage } from "@/features/proposals/ProposalsPage";

const search = z.object({
  status: z.enum(["all", "draft", "in-approval", "sent", "opened", "accepted", "declined", "expired"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/proposals/")({
  validateSearch: search,
  component: () => <ProposalsPage search={Route.useSearch()} />,
});
